export const userRoles = {
    SUPER_ADMIN: "super_admin",
    CLIENT_USER: "client_user",
    CONSULTANT_USER: "consultancy_user"
};
